import { Injectable, Inject } from '@angular/core';
import * as $ from "jquery";
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';

@Injectable()
export class Globals {
    public App_Context: String = "";
	public enableEncDecLogin: boolean = false;
    public CONTEXT_PATH: string = "";
    public REDIRECT_URL: string = "";
    public BACKEND_URL_PREFIX: string = "";
    public KYC_UPLOAD_BACK_URL: string = "";
    public selectedEnv: string = "";
    public EAPPS_CONTEXT_PATH: string = "";
    public EAPPS_URL_PREFIX: string = "";
    constructor() {

        this.selectedEnv = environment.selectedEnv;
        this.CONTEXT_PATH = environment.context;
        this.App_Context = environment.context;
        if (window.location.origin.includes('royalsundaram')) {
            if ( this.selectedEnv == 'UAT') {
				this.enableEncDecLogin = environment.UAT_Ext.enableEncDecLogin;
                this.CONTEXT_PATH = environment.UAT_Ext.CONTEXT_PATH;
                this.REDIRECT_URL = environment.UAT_Ext.REDIRECT_URL;
                this.BACKEND_URL_PREFIX = environment.UAT_Ext.BACKEND_URL_PREFIX;
                this.KYC_UPLOAD_BACK_URL = environment.UAT_Ext.KYC_UPLOAD_BACK_URL;
                this.EAPPS_CONTEXT_PATH = environment.UAT_Ext.EAPPS_CONTEXT_PATH;
                this.EAPPS_URL_PREFIX = environment.UAT_Ext.EAPPS_URL_PREFIX;
            }			
			if ( this.selectedEnv == 'STG') {
				this.enableEncDecLogin = environment.STG_Ext.enableEncDecLogin;
                this.CONTEXT_PATH = environment.STG_Ext.CONTEXT_PATH;
                this.REDIRECT_URL = environment.STG_Ext.REDIRECT_URL;
                this.BACKEND_URL_PREFIX = environment.STG_Ext.BACKEND_URL_PREFIX;
                this.KYC_UPLOAD_BACK_URL = environment.STG_Ext.KYC_UPLOAD_BACK_URL;
                this.EAPPS_CONTEXT_PATH = environment.STG_Ext.EAPPS_CONTEXT_PATH;
                this.EAPPS_URL_PREFIX = environment.STG_Ext.EAPPS_URL_PREFIX;
            }
            if ( this.selectedEnv == 'LIVE') {
				this.enableEncDecLogin = environment.LIVE_Ext.enableEncDecLogin;
                this.CONTEXT_PATH = environment.LIVE_Ext.CONTEXT_PATH;
                this.REDIRECT_URL = environment.LIVE_Ext.REDIRECT_URL;
                this.BACKEND_URL_PREFIX = environment.LIVE_Ext.BACKEND_URL_PREFIX;
                this.KYC_UPLOAD_BACK_URL = environment.LIVE_Ext.KYC_UPLOAD_BACK_URL;
                this.EAPPS_CONTEXT_PATH = environment.LIVE_Ext.EAPPS_CONTEXT_PATH;
                this.EAPPS_URL_PREFIX = environment.LIVE_Ext.EAPPS_URL_PREFIX;
            }
        }else{
            if ( this.selectedEnv == 'UAT') {
				this.enableEncDecLogin = environment.UAT.enableEncDecLogin;
                this.CONTEXT_PATH = environment.UAT.CONTEXT_PATH;
                this.REDIRECT_URL = environment.UAT.REDIRECT_URL;
                this.BACKEND_URL_PREFIX = environment.UAT.BACKEND_URL_PREFIX;
                this.KYC_UPLOAD_BACK_URL = environment.UAT.KYC_UPLOAD_BACK_URL;
                this.EAPPS_CONTEXT_PATH = environment.UAT.EAPPS_CONTEXT_PATH;
                this.EAPPS_URL_PREFIX = environment.UAT.EAPPS_URL_PREFIX;
            }			
			if ( this.selectedEnv == 'STG') {
				this.enableEncDecLogin = environment.STG_Ext.enableEncDecLogin;
                this.CONTEXT_PATH = environment.STG.CONTEXT_PATH;
                this.REDIRECT_URL = environment.STG.REDIRECT_URL;
                this.BACKEND_URL_PREFIX = environment.STG.BACKEND_URL_PREFIX;
                this.KYC_UPLOAD_BACK_URL = environment.STG.KYC_UPLOAD_BACK_URL;
                this.EAPPS_CONTEXT_PATH = environment.STG.EAPPS_CONTEXT_PATH;
                this.EAPPS_URL_PREFIX = environment.STG.EAPPS_URL_PREFIX;
            }
            if ( this.selectedEnv == 'LIVE') {
				this.enableEncDecLogin = environment.LIVE.enableEncDecLogin;
                this.CONTEXT_PATH = environment.LIVE.CONTEXT_PATH;
                this.REDIRECT_URL = environment.LIVE.REDIRECT_URL;
                this.BACKEND_URL_PREFIX = environment.LIVE.BACKEND_URL_PREFIX;
                this.KYC_UPLOAD_BACK_URL = environment.LIVE.KYC_UPLOAD_BACK_URL;
                this.EAPPS_CONTEXT_PATH = environment.LIVE.EAPPS_CONTEXT_PATH;
                this.EAPPS_URL_PREFIX = environment.LIVE.EAPPS_URL_PREFIX;
            }

        }
    }
    public IMAGE_FILE_EXTENSION: string[] = ['jpeg', 'jpg', 'gif', 'bmp', 'png', 'JPEG', 'JPG', 'GIF', 'BMP', 'PNG'];
    public PDF_FILE_EXTENSION: string[] = ['pdf', 'PDF'];
    public EXCEL_FILE_EXTENSION: string[] = ['xlsx', 'xls', 'csv','XLSX', 'XLS', 'CSV'];
    public KYC_PROOF_TYPE: string[] = ['ID_PROOF', 'ADDRESS_PROOF'];
    public KYC_PROOF_IDENTITY: string[] = ['Aadhaar','Pan'];
    public KYC_UPLOAD_IND_PROOF_IDENTITY: any[] = [{ key: "Pan", value: "Pan" },{ key: "id", value: "Aadhaar" },{ key: "voterid", value: "Voter ID" }, { key: "dl", value: "Driving License" }, { key: "passport", value: "Passport" }];
    public KYC_UPLOAD_CORP_PROOF_IDENTITY: any[] = [{ key: "Pan", value: "Pan" }, { key: "GSTIN", value: "GSTIN" }];
    public KYC_SEARCH_TYPE_LIST: any[] = [{ key: "Aadhaar", value: "aadhaar" }, { key: "Pan", value: "pan" }];

    Key_IV = "79994A6EF73DA76C";
    PASSWORD = "EF737CC29DAE7C80644A5B01544CBA61";
    SALT = "12345";

    encoder(str) {
        //let encoder = new TextEncoder();
        //let byteArray = encoder.encode(str)
        return CryptoJS.enc.Utf8.parse(str)
    }

    toWordArray(str) {
        return CryptoJS.enc.Utf8.parse(str);
    }

    public encrypt(value) {
        var key = CryptoJS.PBKDF2(this.PASSWORD, this.SALT, {
            keySize: 128 / 32,
            iterations: 65536
        })
        var encrypted = CryptoJS.AES.encrypt(this.encoder(value), key, {
            iv: this.toWordArray(this.Key_IV),
            padding: CryptoJS.pad.Pkcs7,
            mode: CryptoJS.mode.CBC
        })
        return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    }

    public decrypt(value) {
        var key = CryptoJS.PBKDF2(this.PASSWORD, this.SALT, {
            keySize: 128 / 32,
            iterations: 65536
        })
        var decrypted = CryptoJS.AES.decrypt(value, key, {
            iv: this.toWordArray(this.Key_IV),
            padding: CryptoJS.pad.Pkcs7,
            mode: CryptoJS.mode.CBC
        })
        return decrypted.toString(CryptoJS.enc.Utf8);
    }
}
